var render, staticRenderFns
import script from "./AppImportaPagamentos.vue?vue&type=script&lang=js&"
export * from "./AppImportaPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AppImportaPagamentos.vue?vue&type=custom&index=0&blockType=table&v-if=excelData.length%20%3E%200"
if (typeof block0 === 'function') block0(component)

export default component.exports